module.exports = __webpack_public_path__ + "static/media/3d_portal_mainpage_top_banner.a1644016.jpg";